import React, { forwardRef } from 'react'
import { Skeleton } from '@mui/material'

import PuiHighlight, { PuiHighlightProps } from './PuiHighlight'
import Text, { TextProps } from './Text'

export { TextVariant } from './Text'

export interface TextInteractiveProps extends TextProps {
  readonly HighlightProps?: PuiHighlightProps
  readonly disableSkeletonAnimation?: boolean
  readonly highlight?: string
  readonly isLoading?: boolean
  readonly loaderHeight?: number
  readonly loaderWidth?: number
}

/**
 * Interactive typography component for Rhapsody.
 * Handles interactive user feedback like progress state and highlights.
 * Delegates to `Text` component and passes rest of properties as-is.
 */
const TextInteractive = forwardRef<HTMLSpanElement, TextInteractiveProps>(
  function TextInteractive(
    {
      children,
      isLoading,
      loaderHeight = 20,
      loaderWidth = 70,
      highlight,
      HighlightProps = {},
      disableSkeletonAnimation,
      ...rest
    },
    ref,
  ) {
    if (isLoading) {
      return (
        <Skeleton
          animation={disableSkeletonAnimation ? false : 'pulse'}
          height={loaderHeight}
          variant="text"
          width={loaderWidth}
        />
      )
    }

    return (
      <Text ref={ref} {...rest}>
        {highlight ? (
          <PuiHighlight page searchTerm={highlight} {...HighlightProps}>
            {children}
          </PuiHighlight>
        ) : (
          children
        )}
      </Text>
    )
  },
)

export default TextInteractive
